import { render, staticRenderFns } from "./Datoscontacto.vue?vue&type=template&id=4c6ea6d0&scoped=true"
import script from "./Datoscontacto.vue?vue&type=script&lang=js"
export * from "./Datoscontacto.vue?vue&type=script&lang=js"
import style0 from "./Datoscontacto.vue?vue&type=style&index=0&id=4c6ea6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6ea6d0",
  null
  
)

export default component.exports